<div [id]="getId()" class="modal" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button aria-label="Schließen" class="modal-close-button" data-bs-dismiss="modal" type="button"><span
                        aria-hidden="true"></span></button>
                <h4 class="modal-title">Weiterleitung zur App</h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-xs-12 text-center">
                        <h3 id="redirectInfo">Mit diesem Code wirst Du zur App weitergeleitet.</h3>
                        <br/>
                        <br/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 text-center">
                        <button aria-label="Close" class="btn btn-dark " data-bs-dismiss="modal">Abbrechen</button>
                        <a class="btn btn-primary" href="https://m.digi.schule/626-055-461"
                           id="redirectButton">Weiter</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
